// extracted by mini-css-extract-plugin
export var thumb = "originalCard-module--thumb--1TiqG";
export var content = "originalCard-module--content--2ra1P";
export var category = "originalCard-module--category--2vl2y";
export var btm = "originalCard-module--btm--BYRpw";